var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3488 6.47875L16.7238 5.39625C16.3788 4.79812 15.6144 4.59375 15.0163 4.93875L14.6876 5.12875C13.4376 5.85 11.8751 4.94812 11.8751 3.505V3.125C11.8751 2.43437 11.3157 1.875 10.6251 1.875H9.37506C8.68443 1.875 8.12506 2.43437 8.12506 3.125V3.505C8.12506 4.94812 6.56256 5.85063 5.31256 5.12875L4.98381 4.93875C4.38568 4.59375 3.62131 4.79812 3.27631 5.39625L2.65131 6.47875C2.30631 7.07688 2.51068 7.84125 3.10881 8.18625L3.43756 8.37625C4.68756 9.09813 4.68756 10.9019 3.43756 11.6237L3.10881 11.8138C2.51068 12.1588 2.30631 12.9231 2.65131 13.5213L3.27631 14.6037C3.62131 15.2019 4.38568 15.4062 4.98381 15.0612L5.31256 14.8713C6.56256 14.1494 8.12506 15.0519 8.12506 16.495V16.875C8.12506 17.5656 8.68443 18.125 9.37506 18.125H10.6251C11.3157 18.125 11.8751 17.5656 11.8751 16.875V16.495C11.8751 15.0519 13.4376 14.1494 14.6876 14.8713L15.0163 15.0612C15.6144 15.4062 16.3788 15.2019 16.7238 14.6037L17.3488 13.5213C17.6938 12.9231 17.4894 12.1588 16.8913 11.8138L16.5626 11.6237C15.3126 10.9019 15.3126 9.09813 16.5626 8.37625L16.8913 8.18625C17.4894 7.84125 17.6944 7.07688 17.3488 6.47875Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsLine);
export default __webpack_public_path__ + "static/media/settings_line.2f7888da882827a9f2f30c10b66c357f.svg";
export { ForwardRef as ReactComponent };